import { each } from "fxjs/es";
export class CommandZView {
  constructor({ placeholder_g_el }) {
    this._placeholder_g_el = placeholder_g_el;
  }
  appendTo({ point_container_el }) {
    point_container_el.appendChild(this._placeholder_g_el);
  }
  remove() {
    this._placeholder_g_el.parentNode?.removeChild(this._placeholder_g_el);
  }
  insertNodesBeforeSelf(points) {
    const point_container_el = this._placeholder_g_el.parentElement;
    if (point_container_el != null) {
      each((point) =>
        point_container_el.insertBefore(point, this._placeholder_g_el)
      )(points);
    }
  }
  click(node) {}
}
